import request from '@/api/request'



//PC工作台-项目列表
export function projectList(data) {
    return request({
        url: '/api/director/project/lists',
        method: 'GET',
        params: data
    })
}


//PC工作台-项目添加
export function addProject(data) {
    return request({
        url: '/api/director/project/add',
        method: 'POST',
        data
    })
}



//PC工作台-项目详情
export function projectInfo(data) {
    return request({
        url: '/api/director/project/editDetail',
        method: 'GET',
        params: data
    })
}

//PC工作台-项目修改
export function updateProject(data) {
    return request({
        url: '/api/director/project/update',
        method: 'POST',
        data
    })
}

//PC工作台-项目删除
export function delProject(data) {
    return request({
        url: '/api/director/project/del',
        method: 'POST',
        data
    })
}





//PC工作台-企业列表
export function companyList(data) {
    return request({
        url: '/api/director/project/companyList',
        method: 'GET',
        params: data
    })
}



//PC工作台-项目薪资模版*******************************************//
export function salaryList(data) {
    return request({
        url: '/api/director/projectSalaryTpl/lists',
        method: 'GET',
        params: data
    })
}

//添加薪资模版
export function addSalary(data) {
    return request({
        url: '/api/director/projectSalaryTpl/add',
        method: 'POST',
        data
    })
}


export function editSalary(data) {
    return request({
        url: '/api/director/projectSalaryTpl/edit',
        method: 'POST',
        data
    })
}


export function delSalary(data) {
    return request({
        url: '/api/director/projectSalaryTpl/del',
        method: 'GET',
        params: data
    })
}






//PC工作台-项目合同模版
export function contractTplList(data) {
    return request({
        url: '/api/director/projectContractTpl/lists',
        method: 'GET',
        params: data
    })
}

export function addContractTpl(data) {
    return request({
        url: '/api/director/projectContractTpl/add',
        method: 'POST',
        data
    })
}

export function editContractTpl(data) {
    return request({
        url: '/api/director/projectContractTpl/edit',
        method: 'POST',
        data
    })
}


export function delContractTpl(data) {
    return request({
        url: '/api/director/projectContractTpl/del',
        method: 'GET',
        params: data
    })
}